import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodSearchValidator } from '@tanstack/router-zod-adapter';
import z from 'zod';

import { ContractState } from '../../types/ContractMessage';
import { ContractsOverviewPage } from '../contracts/overview/ContractsOverviewPage';

const contractsSearchSchema = z.object({
    page: fallback(z.number(), 0).default(0),
    states: z.array(z.nativeEnum(ContractState)).optional(),
    validUntilFrom: z.string().optional(),
    validUntilTo: z.string().optional(),
    supplierIds: z.array(z.string()).optional(),
    customerGroupId: z.string().optional(),
    customerIds: z.array(z.string()).optional(),
    evergreen: z.boolean().optional(),
    searchQuery: z.string().optional(),
});

export const Route = createFileRoute('/_app/contracts/')({
    component: ContractsOverviewPage,
    validateSearch: zodSearchValidator(contractsSearchSchema),
});
